"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _helpers = require('./helpers');
var _utils = require('shared/store/utils');
var _actionCreators = require('shared/actions/actionCreators'); var _actionCreators2 = _interopRequireDefault(_actionCreators);
var _bus = require('shared/services/bus'); var _bus2 = _interopRequireDefault(_bus);



const patientImportActions = _utils.createAsyncActions('PatientImport')
const superPatientImportActions =
  _utils.createAsyncActions('SuperPatientImport')

// The server's error text when a command failed (a CommandError carries it on
// `Error`), otherwise the rejection's own message.
const failureMessage = (e) => {
  const serverError = e !== null && typeof e === 'object' ? (e ).Error : undefined
  if (typeof serverError === 'string' && serverError) return serverError
  return e instanceof Error ? e.message : undefined
}

const withImportFlow = (cmd) =>
  new Promise((resolve, reject) => {
    const ttl = 5 * 60 * 1000 // 5 minutes
    const completeType = _actionCreators2.default.patientImportCompleteNotificationAction.type
    // Settles once: a late command failure after the timeout (or the reverse)
    // must not unsubscribe again, since bus.off of a missing handler removes
    // another listener.
    let settled = false

    const handleComplete = (action) => {
      if (settled) return
      settled = true
      clearTimeout(timeout)
      const payload = action.payload 
      if (!payload.TaskCompletedFully) {
        reject(new Error(payload.Error || 'Patient import failed'))
      } else if (payload.RowsSuccess > 0) {
        return resolve(payload)
      } else {
        reject(new Error('Found no patients to import'))
      }
    }

    const timeout = setTimeout(() => {
      if (settled) return
      settled = true
      _bus2.default.off(completeType, handleComplete)
      reject(new Error('Patient import has timed out'))
    }, ttl)

    _bus2.default.once(completeType, handleComplete)

    // A failed command never starts the import: stop waiting and reject with
    // an Error carrying the server's message (wsCommand has already logged it).
    cmd.catch((e) => {
      if (settled) return
      settled = true
      clearTimeout(timeout)
      _bus2.default.off(completeType, handleComplete)
      reject(new Error(failureMessage(e) || 'Patient import failed'))
    })
  })

const patientImport = (req) =>
  withImportFlow(_helpers.wsCommand('PatientImport', patientImportActions, req, null))

const superPatientImport = (req) =>
  withImportFlow(
    _helpers.wsCommand('SuperPatientImport', superPatientImportActions, req, null),
  )

exports. default = {
  patientImport,
  superPatientImport,
}
